import React from "react";
import { Collapse } from "antd";
import trans from "../../utils";

/**
 * Renders a submitted RepeatingGroup value in a read-only submission view.
 *
 * `item` is the normalized submitted field:
 *   { key, name, title, value: { items: [ { <childKey>: <childValue>, ... }, ... ] } }
 *
 * `groupFieldDefs` are the schema field definitions for the group's children
 * (resolved from the pinned form schema), used to recover titles/types since
 * the submitted item values are stored as plain key -> value maps.
 *
 * Items are collapsed by default; the user can expand each one individually.
 */
export default function RepeatingGroupSubmissionView({ item, groupFieldDefs, getInputType }) {
	const items = item?.value?.items;

	if (!Array.isArray(items) || items.length === 0) {
		return (
			<div className="display-border p-2">
				<strong>{item?.title || item?.key}</strong>: {trans("No items")}
			</div>
		);
	}

	const collapseItems = items.map((itemValues, index) => ({
		key: String(index),
		label: `${trans("Item")} ${index + 1}`,
		children: (groupFieldDefs || []).map((childDef) => {
			const hydratedItem = {
				...childDef,
				value: itemValues?.[childDef.key],
			};
			return (
				<div key={childDef.key} className="mb-2">
					{getInputType(hydratedItem) || (
						<div className="display-border p-2">
							<strong>{childDef.title || childDef.key}</strong>:{" "}
							{hydratedItem.value != null ? String(hydratedItem.value) : "-"}
						</div>
					)}
				</div>
			);
		}),
	}));

	return (
		<div className="display-border p-2">
			<strong>{item?.title || item?.key}</strong>
			<Collapse
				style={{ marginTop: 8 }}
				items={collapseItems}
				defaultActiveKey={[]}
			/>
		</div>
	);
}
